<template>
  <div class="recharge-page-container row">
    <div class="main row" v-loading="loading">
      <div class="nav row">
        <div class="title" v-if="userInfo">欢迎{{userInfo.username}}</div>
        <div class="tip" v-if="userInfo"><span>您的会员期限截止到{{userInfo.expire_at}}，感谢您的使用和支持！</span></div>
      </div>
      <div class="recharge-main row">
        <div class="left row">
          <div class="title2">会员付费</div>
          <div class="info">
            <div class="blue title3">账号信息</div>
            <div class="item">
              <span class="gray label">用户昵称：</span>
              <span v-if="userInfo">{{userInfo.username}}</span>
            </div>
            <div class="item">
              <span class="gray label">账号ID：</span>
              <span v-if="userInfo">{{userInfo.uuid}}</span>
            </div>
            <div class="item">
              <span class="gray label">注册类型：</span>
              <span v-if="userInfo">{{roleMap}}</span>
            </div>
          </div>
          <div class="permission-escription">
            <div class="blue title3">会员权限说明</div>
            <div class="content"> 研报酷是和见微数据合作的第三方服务，目前合作方式如下：购买研报酷的会员服务，并不能同时享有见微数据的会员权限；购买见微数据的会员服务，可同时享有研报酷的会员权限。
            </div>
          </div>
          <div class="pay-plain">
            <div class="blue title3">付费方案</div>
            <div class="pay-plain row">
              <div
                @click="payPlain=plain"
                class="item row"
                v-for="(plain, index) in payPlainsMap"
                :class="{'active': payPlain.Name===plain.Name}"
                :key="index">
                <div class="pay-plain-item-name gray">{{plain.Name}}</div>
                <div class="pay-plain-item-money">¥{{plain.Price}}</div>
                <div class="pay-plain-item-originalMoney"></div>
              </div>
            </div>
          </div>
          <div class="pay-methods row">
            <div class="blue title3">支付方式</div>
            <div class="radio row">
              <el-radio class="radio-item-middle-align row" v-model="radio" label="1">
                <img class="img-pay" src="../assets/img/wechat-pay.svg">
                <span>&nbsp;&nbsp;微信支付</span>
              </el-radio>
              <!-- <el-radio class="radio-item-middle-align row" v-model="radio" label="2">
                <img class="img-pay" src="../assets/img/zhifubao-pay.svg">
                <span>&nbsp;&nbsp;支付宝支付</span>
              </el-radio> -->
            </div>
            <div class="qrcode" v-loading="qrcodeLoading">
                 <img width='184' src="../assets/img/errorCode.png">
              <!-- <div id="qrcode" v-if="link"></div> -->
            </div>
          </div>
        </div>
        <div class="right row">
          <div class="title2">会员与普通用户功能对比</div>
          <table>
            <thead>
              <tr>
                <td class="gray">功能特权</td>
                <td class="border-left gray">会员</td>
                <td class="border-left gray">普通用户</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>标题搜索</td>
                <td class="border-left">
                  <img src="../assets/img/check-number-blue.svg">
                </td>
                <td class="border-left">
                  <img src="../assets/img/check-number-blue.svg">
                </td>
              </tr>
              <tr>
                <td>全文搜索</td>
                <td class="border-left">
                  <img src="../assets/img/check-number-blue.svg">
                </td>
                <td class="border-left">
                  <img src="../assets/img/check-number-blue.svg">
                </td>
              </tr>
              <tr>
                <td>过滤条件</td>
                <td class="border-left">
                  <img src="../assets/img/check-number-blue.svg">
                </td>
                <td class="border-left">
                  <img src="../assets/img/check-number-blue.svg">
                </td>
              </tr>
              <tr>
                <td>搜索结果查看</td>
                <td class="border-left blue">查看前500条结果</td>
                <td class="border-left gray">仅可查看前20条</td>
              </tr>
              <tr>
                <td>研报下载</td>
                <td class="border-left blue">500/天</td>
                <td class="border-left">
                  <img src="../assets/img/close.svg">
                </td>
              </tr>
              <tr>
                <td>批量下载</td>
                <td class="border-left">
                  <img src="../assets/img/check-number-blue.svg">
                </td>
                <td class="border-left">
                  <img src="../assets/img/close.svg">
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/rest/questionQuery";
// eslint-disable-next-line
import QRCode from "qrcodejs2";

export default {
  name: "RechargePage",
  data() {
    return {
      loading: false,
      qrcodeLoading: false,
      userInfo: null,
      payPlainsMap: null,
      payPlain: null,
      radio: "1",
      link: null,
      wechatOrderInfo: null,
      qrcode: null,
      rechargeResultMap: {
        SUCCESS: "success",
        FAIL: "fail",
        REFUND: "fail",
        CLOSED: "fail",
        REVOKED: "fail",
        PAYERROR: "fail"
      },
      windowInterval: null
    };
  },
  computed: {
    // eslint-disable-next-line
    roleMap() {
      if (this.userInfo) {
        if (this.userInfo.phone) {
          return "手机号注册";
          // eslint-disable-next-line
        } else if (this.userInfo.wxid) {
          return "微信扫码注册";
        }
      }
    }
  },
  watch: {
    // payPlain() {
    //   this.launchPayment();
    // }
    // link(val) {
    //   if (val) {
    //     this.$nextTick(() => {
    //       this.createQrCode();
    //     });
    //   }
    // }
  },
  methods: {
    createQrCode() {
      this.qrcode = new QRCode("qrcode", {
        width: 184,
        height: 184,
        text: this.link
      });
    },
    async getPayProduct() {
      this.loading = true;
      try {
        const res = await api.getPayProduct();
        this.payPlainsMap = res;
        this.payPlain = res[0];
        this.loading = false;
      } catch (err) {
        if (err.response && err.response.msg) {
          this.$message.error(err.response.msg);
        } else {
          this.$message.error("数据请求错误");
        }
        this.loading = false;
      }
    },
    async launchPayment() {
      this.qrcodeLoading = true;
      try {
        const res = await api.postWechatOrder(this.payPlain.UID);
        this.wechatOrderInfo = res;
        this.link = null;
        this.$nextTick(() => {
          this.link = res.codeURL;
        });
        this.qrcodeLoading = false;
      } catch (err) {
        if (err.response && err.response.msg) {
          this.$message.error(err.response.msg);
        } else {
          this.$message.error("二维码请求错误");
        }
        this.qrcodeLoading = false;
        this.link = null;
      }
    },
    async getUserInfo() {
      this.loading = true;
      try {
        const res = await api.getUserInfo();
        this.userInfo = res;
        this.loading = false;
      } catch (err) {
        if (err.response && err.response.msg) {
          this.$message.error(err.response.msg);
        } else {
          this.$message.error("数据请求错误");
        }
        this.loading = false;
      }
    },
    async getRechargeResult() {
      if (!this.wechatOrderInfo) return;
      try {
        const res = await api.getRechargeResult(this.wechatOrderInfo.tradeNo);
        if (this.rechargeResultMap[res.data.trade_state]) {
          this.$router.push(
            `recharge-result?orderstatus=${this.rechargeResultMap[res.data.trade_state]}`
          );
        }
      } catch (err) {
        console.log(err);
      }
    },
    async init() {
      await this.getUserInfo();
      await this.getPayProduct();
    }
  },
  async mounted() {
    await this.init();
    this.windowInterval = window.setInterval(this.getRechargeResult, 1000);
  },
  beforeDestroy() {
    window.clearInterval(this.windowInterval);
  },
  components: {
    // eslint-disable-next-line
    QRCode
  }
};
</script>

<style lang="scss" scoped>
.title2 {
  font-size: 16px;
  color: #171f46;
}
.title3 {
  margin-top: 24px;
  margin-bottom: 10px;
}
.blue {
  color: #2b76ff;
}
.gray {
  color: #747990;
}
.recharge-page-container {
  margin-bottom: 28px;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: calc(100% - 64px);
  overflow: auto;
  background-color: #f7f7fa;
  box-sizing: border-box;
  .main {
    margin-top: 24px;
    margin-bottom: 32px;
    padding: 24px 32px;
    flex-direction: column;
    flex-shrink: 0;
    align-items: center;
    width: 1200px;
    height: 950px;
    min-height: 950px;
    border: 1px solid #ffffff;
    background-color: #ffffff;
    box-sizing: border-box;
    .nav {
      flex-direction: column;
      justify-content: space-between;
      width: 100%;
      height: 72px;
      flex-shrink: 0;
      .title {
        color: #171f46;
        font-size: 24px;
      }
      .tip {
        color: #747990;
        font-size: 14px;
      }
    }
    .recharge-main {
      margin-top: 24px;
      width: 100%;
      height: 800px;
      color: #171f46;
      font-size: 14px;
      min-height: 800px;
      border: 1px solid #e5e6ee;
      flex-shrink: 0;
      .left {
        flex-direction: column;
        padding: 24px;
        width: 530px;
        height: 100%;
        border-right: 1px solid #e5e6ee;
        box-sizing: border-box;
        .info {
          .item {
            margin-top: 10px;
            .label {
              display: inline-block;
              width: 70px;
            }
            &:first-child {
              margin-top: 0;
            }
          }
        }
        .permission-escription {
          .content {
            color: #747990;
          }
        }
        .pay-plain {
          .pay-plain {
            justify-content: space-between;
            .item {
              flex-direction: column;
              justify-content: space-around;
              align-items: center;
              width: 154px;
              height: 145px;
              border: solid 1px #e5e6ee;
              box-sizing: border-box;
              cursor: pointer;
              .pay-plain-item-name {
                font-size: 24px;
              }
              .pay-plain-item-money {
                font-size: 32px;
                color: #e64c62;
              }
              .pay-plain-item-originalMoney {
                text-decoration: line-through;
              }
              &.active {
                background-color: rgba(228, 183, 126, 0.1);
                border: solid 2px #e4b77e;
              }
            }
          }
        }
        .pay-methods {
          flex-direction: column;
          width: 100%;
          .radio {
            .img-pay {
              width: 32px;
              height: 32px;
            }
            .radio-item-middle-align {
              align-items: center;
            }
          }
          .qrcode {
            margin-top: 32px;
            align-self: center;
            width: 184px;
            height: 184px;
            background-color: #0000000a;
          }
        }
      }
      .right {
        flex-direction: column;
        flex: 1;
        height: 100%;
        box-sizing: border-box;
        .title2 {
          padding: 24px;
        }
        table {
          border-collapse: collapse;
          thead {
            background-color: rgba(0, 11, 92, 0.03);
            td {
              padding: 13px 16px;
            }
          }
          td {
            padding: 8px 16px;
            box-shadow: inset 0px -1px 0px 0px #f2f3f7;
            &:first-child {
              padding-left: 24px;
            }
          }
          .border-left {
            border-left: 1px solid #e5e6ee;
          }
        }
      }
    }
  }
}
</style>
